import { render, staticRenderFns } from "./GroupPositions.html?vue&type=template&id=9cf18788&scoped=true&"
import script from "./GroupPositions.vue?vue&type=script&lang=js&"
export * from "./GroupPositions.vue?vue&type=script&lang=js&"
import style0 from "./GroupPositions.vue?vue&type=style&index=0&id=9cf18788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf18788",
  null
  
)

export default component.exports